import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '../../../cashier-payments';
import { AppInstance } from '@wix/cashier-common/dist/src/types/AppInstance';
import { DeviceType } from '../../../types/DeviceType';
import { AsyncPaymentResult } from '../../../sdk/types/AsyncPaymentResult';

export interface InstantPaymentDetails {
  paymentMethod: PaymentMethod;
  paymentProvider: PaymentProvider;
  methodIcon: string;
  chargeId: string;
  orderId: string;
  amount: string;
  currency: string;
  qrCode: {
    payload?: string;
    url?: string;
  };
  expireDate: string;
}

export enum InstantPaymentMessageType {
  // Widget -> Frame
  Init = 'init',

  // Frame -> Widget
  Ready = 'frame-ready',
  PaymentCompleted = 'instant-payment-completed',
  PaymentCancelled = 'instant-payment-cancelled',
  PaymentTimeout = 'instant-payment-timeout',
  Error = 'instant-payment-error',
}

export type InstantPaymentInitPayload = {
  locale: string;
  translations: { [key: string]: string };
  paymentDetails: InstantPaymentDetails;
  deviceType: DeviceType;
  appInstance?: AppInstance;
};

export type InstantPaymentMessageToFrame = {
  type: InstantPaymentMessageType.Init;
  payload: InstantPaymentInitPayload;
};

export type InstantPaymentMessageFromFrame =
  | {
      type: InstantPaymentMessageType.Ready;
    }
  | {
      type: InstantPaymentMessageType.PaymentCancelled;
    }
  | {
      type: InstantPaymentMessageType.PaymentTimeout;
    }
  | {
      type: InstantPaymentMessageType.PaymentCompleted;
      payload: AsyncPaymentResult;
    }
  | {
      type: InstantPaymentMessageType.Error;
      error: any;
    };
